import styled, { css } from 'styled-components';
import { Placeholder } from '@lmn/design-system';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider';
import { useIsMobile } from '@/app/components/search/utils/useSsrMedia';
import { TransportDetailsContainer } from '@/app/components/hotel-detail/evo/transport/EvoTransportDetailsCard/styled';
import {
  CardContainer,
  CardContent,
  CardWrapper,
  TransportDivider,
  TransportCardSection,
  PriceAndButtonWrapper,
  PriceArea,
} from '@/app/components/hotel-detail/evo/transport/EvoTransportCardStyled';

const SkeletonTransportCardSection = styled.div<{ $isOutBound: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;

  ${({ $isOutBound }) =>
    $isOutBound
      ? css`
          margin-bottom: 12px;
          @media (min-width: 768px) {
            margin-bottom: 0;
            width: 50%;
            padding-right: 24px;
          }
        `
      : css`
          margin-top: 12px;
          @media (min-width: 768px) {
            margin-top: 0;
            width: 50%;
            padding-left: 24px;
          }
        `}
`;

const SkeletonResponsiveDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${(p) => p.theme.kallisto.color.border.static.borderNeutral};

  @media (min-width: 768px) {
    width: 1px;
    height: auto;
    align-self: stretch;
  }
`;

const SkeletonFooterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const SkeletonPriceBox = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;

  @media (min-width: 768px) {
    flex: none;
  }
`;

const SkeletonButtonWrapper = styled.div`
  flex-shrink: 0;

  @media (min-width: 768px) {
    width: 100%;
  }
`;

export function EvoTransportCardSkeleton() {
  const { commonData } = usePageWrapperData();
  const isMobile = useIsMobile(commonData.isMobileDevice);

  return (
    <CardContainer>
      <CardWrapper $isSelected={false}>
        <CardContent>
          <TransportCardSection>
            <TransportDetailsContainer $isMobile={isMobile}>
              <SkeletonTransportCardSection $isOutBound={true}>
                <Placeholder height="20px" width="116px" />
                <Placeholder height="40px" width="100%" />
              </SkeletonTransportCardSection>
              <SkeletonResponsiveDivider />
              <SkeletonTransportCardSection $isOutBound={false}>
                <Placeholder height="20px" width="116px" />
                <Placeholder height="40px" width="100%" />
              </SkeletonTransportCardSection>
            </TransportDetailsContainer>
            <TransportDivider />
            <SkeletonFooterRow>
              <Placeholder height="28px" width="107px" />
              <Placeholder height="28px" width={isMobile ? '73px' : '107px'} />
            </SkeletonFooterRow>
          </TransportCardSection>
          <PriceArea>
            <PriceAndButtonWrapper>
              <SkeletonPriceBox>
                <Placeholder height="22px" width={isMobile ? '60px' : '93px'} />
              </SkeletonPriceBox>
              <SkeletonButtonWrapper>
                <Placeholder height="48px" width={isMobile ? '143px' : '100%'} />
              </SkeletonButtonWrapper>
            </PriceAndButtonWrapper>
          </PriceArea>
        </CardContent>
      </CardWrapper>
    </CardContainer>
  );
}
